export const generateHourOptions = () =>
  new Array(48).fill(undefined).map((_, index) => {
    const hour = Math.floor(index / 2);
    const minutes = index % 2 === 0 ? 0 : 30;
    return `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  });
